// extracted by mini-css-extract-plugin
export var subtitle = "_bj-2";
export var title = "_bj-0";
export var titleNoWrap = "_bj-1";